<script>
  import { _ } from "svelte-i18n"
  import { isEmpty } from 'lodash'
  import { previews_nav_filters, previews_are_google_fonts, detected_fonts, system_fonts, user_valid, previews_are_zoomed, previews_storefronts_filter, modals, storefront_id_to_edit, user, user_storefronts} from './../stores'
  import { handleUpsell, goToLocallyStoredNavItem } from '../modules/helpers'
  import { saveSelection } from "../services/selections";
  import { sendPageViewToAnalytics } from '../modules/helpers'
  import GoogleFontsToggle from './GoogleFontsToggle.svelte'
  import FontsNavSearch from './FontsNavSearch.svelte'
  import PreviewsSelectedActions from './PreviewsSelectedActions.svelte'
  import StorefrontActions from "./StorefrontActions.svelte";
  import Button from '../elements/Button.svelte';
  export let selectedStorefront;

  $: showNewStorefrontButton = $user && $previews_nav_filters.storefront && !$previews_storefronts_filter

  function locallyStoreNavFilter() {
    localStorage.setItem('previews_nav_filters', JSON.stringify($previews_nav_filters))
  }

  // TODO: This function is duplicated in filterSelectedToggle component
  function toggleSelected() {
    if ($previews_nav_filters.selected) {
			goToLocallyStoredNavItem()
		}
		else {
			previews_nav_filters.filterSelected()
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth'})
      // auto-saving filtered selection
			saveSelection(undefined, true)
      sendPageViewToAnalytics('Selected Fonts', 'https://wordmark.it/selected-fonts')
		}
  }

  function handleAllFontsClick() {
    previews_nav_filters.showAll()
    locallyStoreNavFilter()
  }

  function handleYourFontsClick() {
    previews_nav_filters.filterYours()
    locallyStoreNavFilter()
    sendPageViewToAnalytics('Your Fonts', 'https://wordmark.it/your-fonts')
  }

  function handleDroppedFontsClick() {
    previews_nav_filters.filterDropped()
    sendPageViewToAnalytics('Dropped Fonts', 'https://wordmark.it/dropped-fonts')
  }

  function handleUploadedFontsClick() {
    previews_nav_filters.filterUploaded()
    sendPageViewToAnalytics('Uploaded Fonts', 'https://wordmark.it/uploaded-fonts')
  }

  function handleTaggedFontsClick() {
    previews_nav_filters.filterTagged()
    if ($user_valid) locallyStoreNavFilter()
    sendPageViewToAnalytics('Tagged Fonts', 'https://wordmark.it/tagged-fonts')
  }

  function handleStorefrontClick() {
    sendPageViewToAnalytics('Storefronts', 'https://wordmark.it/storefronts')
    previews_nav_filters.filterStorefront()
  }


  function handleStorefrontRootClick() {
    previews_storefronts_filter.reset()
  }
  
  function handleGoogleFontsClick() {
    handleUpsell('google')
    sendPageViewToAnalytics('Google Fonts', 'https://wordmark.it/google-fonts')
  }

  function openNewStorefrontModal() {
    $storefront_id_to_edit = null
    modals.open('editStorefront')
  }

  if (isEmpty($detected_fonts)) handleYourFontsClick()

</script>

<ul class="fontsNav">

  <!-- If Storefronts and selected storefront-->
  {#if $previews_nav_filters.storefront && !!$previews_storefronts_filter}
    <li 
      on:click={() => handleStorefrontRootClick()}
      class:active={$previews_nav_filters.storefront && !$previews_storefronts_filter}
      >
      {$_('navigation.storefronts')}
    </li>
    <!-- show filtered storefront name -->
    {#if !!$selectedStorefront}
      <li class="divider">&rarr;</li>
      <li
        class:active={true}>
        {$selectedStorefront.name}
      </li>
      <StorefrontActions {selectedStorefront} />
    {/if}
  <!-- Else -->
  {:else}
    <!-- Filter Selected -->
    {#if $previews_nav_filters.selected}
      <li 
        on:click={() => toggleSelected()}
        class="active">
        {$_('navigation.selectedFonts')}
      </li>
    {/if}

    <!-- HIDE THIS BLOCK WHEN SELECTED or ZOOMED -->
    {#if !$previews_nav_filters.selected || $previews_are_zoomed}
      <!-- All/AllGoogle Fonts -->
      <li
        on:click={handleAllFontsClick}
        class:active={isEmpty($previews_nav_filters)}>
        {$previews_are_google_fonts ? $_('navigation.googleFonts') : $detected_fonts !== $system_fonts ? $_('navigation.allFonts') : $_('navigation.systemFonts')}
      </li>
      {#if !$previews_are_google_fonts}
        <!-- Your Fonts -->
        <li
          on:click={handleYourFontsClick}
          class:active={$previews_nav_filters.user && $previews_nav_filters.tagged === undefined}>
          {$_('navigation.yourFonts')}
        </li>
        {#if $previews_nav_filters.tagged === false}
          <!-- Untagged Fonts -->
          <li
            class:active={$previews_nav_filters.tagged === false}>
            {$_('navigation.untaggedFonts')}
          </li>
        {:else}
          <!-- Tagged Fonts -->
          <li
            on:click={handleTaggedFontsClick}
            class:active={$previews_nav_filters.tagged}>
            {$_('navigation.tagged')}<span class="show-sm"> Fonts</span>
          </li>
        {/if}
        <!-- Dropped Fonts -->
        <li
          on:click={handleDroppedFontsClick}
          class:active={$previews_nav_filters.dropped && $previews_nav_filters.tagged === undefined}>
          {$_('navigation.dropped')}<span class="show-sm"> Fonts</span>
        </li>
        <!-- Uploaded Fonts -->
        <li
          on:click={handleUploadedFontsClick}
          class:active={$previews_nav_filters.uploaded}>
          {$_('navigation.uploaded')}<span class="show-sm"> Fonts</span>
        </li>
      {/if}

      <!-- Search -->
      <li 
        class="search" 
        class:pro_only={!$user_valid} 
        on:click={() => handleUpsell('search')}>
        <FontsNavSearch/>
      </li>
      <li class="divider">/</li>

      <!-- Storefronts -->
      {#if !$previews_are_google_fonts}
        <li 
          on:click={() => handleStorefrontClick()}
          class:active={$previews_nav_filters.storefront}>
          {$_('navigation.storefronts')}
        </li>
      {/if}

      <!-- Google Fonts Toggle -->
      <li 
        class:pro_only={!$user_valid && !$previews_are_google_fonts} 
        on:click={handleGoogleFontsClick}>
        <GoogleFontsToggle on:toggleGoogleFonts/>
      </li>
    {/if}
    <!-- SHOW SELECTED ACTIONS WHEN SELECTED or ZOOMED-->
    {#if $previews_nav_filters.selected || $previews_are_zoomed}
      <PreviewsSelectedActions />
    {/if}
  {/if}

  <!-- If at Storefronts indexand no selected storefront-->
  {#if showNewStorefrontButton}
    <li class="right hasbutton">
      <Button on:click={openNewStorefrontModal}>{$user_storefronts.length > 0 ? "Add new storefront" : "Create new storefront"}</Button>
    </li>
  {/if}
</ul>

<style>
  ul {
    display: flex;
    flex-direction: row;
    gap: 1.5rem;
    width: 100%;
    padding: 2rem;
    font-family: var(--PensumSans);
    font-size: 2.2rem;
		line-height: 4rem;
    background-color: var(--c-nav-bg);
    color: var(--c-text-faded);
  }
  ul li {
    position: relative;
    display: inline-block;
    transition: color var(--transition-props);
  }
  ul li:not(.divider):not(.active):hover {
    cursor: pointer;
    color: var(--c-text-hover);
  }
  ul li.divider {
    cursor: default;
  }

  ul li.active {
    color: var(--c-accent);
  }
  ul li.right {
    margin-left: auto;
  }
  ul li.hasbutton :global(button) {
    vertical-align: top;
  }

  ul li span.show-sm {
    display: none;
  }


  @media only screen and (max-width: 1024px) {
    ul {
      flex-direction: column;
      gap: 0;
    }
    ul li span.show-sm {
      display: inline;
    }
    ul li.divider {
      display: none;
    }
    ul li.search {
      margin-left: -0.3rem;
    }
  }
</style>